module.exports = __webpack_public_path__ + "img/mcampos-branco.abd3f282.svg";